export default __webpack_public_path__ + "static/media/No4.ed0a8cf6.jpg";